import React, { Component } from 'react';
import { Header, Grid, Input } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { profileSelector, appSelector } from '../../selectors';
import * as profileActions from '../../actions/profileActions';
import styles from './AccountInformationPage.module.scss';

class AccountInformationPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editName: false,
			profileName: props.profile.name
		};
		this.onEditClick = this.onEditClick.bind(this);
		this.onNameChange = this.onNameChange.bind(this);
		this.onSaveClick = this.onSaveClick.bind(this);
		this.onCancelClick = this.onCancelClick.bind(this);
	}

	onEditClick(e) {
		e.preventDefault();
		this.setState({ editName: true });
	}

	onNameChange(e, { value }) {
		this.setState({ profileName: value });
	}

	async onSaveClick(e) {
		e.preventDefault();
		const { profile, actions } = this.props;
		const { profileName } = this.state;
		await actions.updateName({ ...profile, name: profileName });
		this.setState({ editName: false, profileName: profileName });
	}

	onCancelClick(e) {
		e.preventDefault();
		const { profile } = this.props;
		this.setState({ editName: false, profileName: profile.name });
	}

	render() {
		const { profile, app } = this.props;
		const { editName, profileName } = this.state;
		return (
			<div>
				<Header as='h3' content='Account Information' color='red' />
				<Grid>
					<Grid.Row>
						<Grid.Column width={6}>
							<Header as='h4' content='Display Name' style={{ marginRight: '15px' }} />
						</Grid.Column>
						<Grid.Column width={10}>
							{editName ? (
								<div className={styles.editContainer}>
									<Input value={profileName} onChange={this.onNameChange} />
									<div className={styles.editActions}>
										<a href='/profile/security/name' onClick={this.onSaveClick}>
											<Header as='h4' content='save' style={{ color: '#4183c4', margin: 10 }} />
										</a>
										<a href='/profile/security/name' onClick={this.onCancelClick}>
											<Header as='h4' content='cancel' style={{ color: '#4183c4', margin: 10 }} />
										</a>
									</div>
								</div>
							) : (
								<div style={{ display: 'flex' }}>
									<Header as='h4' content={profile.name} style={{ marginRight: '15px' }} />{' '}
									<a href='/profile/profile/name' onClick={this.onEditClick}>
										<Header as='h4' content='edit' style={{ color: '#4183c4' }} />
									</a>
								</div>
							)}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={6}>
							<Header as='h4' content='Username and Password' style={{ marginRight: '15px' }} />
						</Grid.Column>
						<Grid.Column width={10}>
							<div>{profile.email}</div>
							<div>**********</div>
						</Grid.Column>
					</Grid.Row>
					{app.systemToggles.electronicAlertsEnabled || profile.isDeliveryTester ? (
						<Grid.Row>
							<Grid.Column width={6}>
								<Header as='h4' content='Paperless/Alerts' style={{ marginRight: '15px' }} />
							</Grid.Column>
							<Grid.Column width={10}>{profile.isDelivery ? 'Signed Up' : 'No'}</Grid.Column>
						</Grid.Row>
					) : null}
					<Grid.Row>
						<Grid.Column width={6}>
							<Header as='h4' content='Policies' style={{ marginRight: '15px' }} />
						</Grid.Column>
						<Grid.Column width={10}>
							{profile.policies.map((p, idx) => (
								<div key={idx}>{p.policyNumber}</div>
							))}
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}

AccountInformationPage.propTypes = {};

const mapStateToProps = (state, ownProps) => {
	return {
		app: appSelector(state),
		profile: profileSelector(state)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(profileActions, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountInformationPage);
